
export const debounceAmplitudeScriptTracking = (eventName, customProps) => {
  if (window.amplitude) {
   window.amplitude.track(eventName, customProps)
   window.amplitude.flush()
  }
}
